import axiosApiInstance from "../../interceptors/axiosApiInstance";
import { BASE_URL } from "../config";

const MateDriveService = {
  getFilterMateService: async function (
    actionName = "FILELIST",
    path = "/",
    q = "",
    newName = "",
    flowId = ""
  ) {
    try {
      const response = await axiosApiInstance.post(await BASE_URL + "/matedrive/", {
        libraryName: "MATEDRIVE",
        actionName,
        path,
        q,
        newName,
        flowId,
      });
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  checkFileExists: async function (
    automId = "",
    fileName = "",
    path = "/"
  ) {
    try {
      const response = await axiosApiInstance.post(await BASE_URL + "/matedrive/file/exists", {
        libraryName: "MATEDRIVE",
        actionName: "CHECKFILEEXISTS",
        path,
        fileName,
        automId,
      });
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
  uploadFile: async function (file, path, flowId) {//
    try {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("path", path);
      formData.append("flowId", flowId);
      const response = await axiosApiInstance.post(
        await BASE_URL + "/matedrive/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return error.response ? error.response.data : undefined;
    }
  },
};

export default MateDriveService;
